export const css = {
	oneaction: '_212vHfQY',
	' _key': 'apic-theme/apic/quiz-widgets/flashcard'
};

export default css;
